import API from '../../../API/api';

export const redeemVoucher = async (voucherValue, recaptchaToken) => {
  try {
    let response;
    response = await API.POST({
      apiPath: '/api/v2/cart/promotion/voucher/',
      data: JSON.stringify({
        voucherValue,
        recaptchaToken: recaptchaToken || undefined,
      }),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
    });

    return Promise.resolve(response);
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};
